import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SettingsProvider } from "@/context/SettingsContext";
import { CopyProvider } from "@/context/CopyContext";
import { GaPageViews } from "@/components/GaPageViews";
import { B2BLayout } from "@/components/b2b/B2BLayout";
import { B2CLayout } from "@/components/b2c/B2CLayout";
import Home from "@/pages/b2b/Home";
import Contact from "@/pages/b2b/Contact";
import Signup from "@/pages/b2b/Signup";
import { About, Solutions, WhiteLabel, Affiliate, Faq, Privacy, Terms } from "@/pages/b2b/StaticPages";
import { WhatIsSellvago, SellvagoVsB2bOta, HowWhiteLabelWorks, HowResellersGrow } from "@/pages/b2b/Positioning";
import FlightsHome from "@/pages/b2c/FlightsHome";
import CampaignPage from "@/pages/b2c/CampaignPage";
import SeasonPage from "@/pages/b2c/SeasonPage";
import AffiliateLanding from "@/pages/b2c/AffiliateLanding";
import AffiliateStats from "@/pages/b2c/AffiliateStats";
import { ArticlesList, ArticleDetail } from "@/pages/b2c/Articles";
import { Deals, PopularRoutes } from "@/pages/b2c/ListPages";
import GoRedirect from "@/pages/b2c/GoRedirect";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { isB2CHost } from "@/lib/host";
import { captureAttribution } from "@/lib/attribution";

const b2b = (el) => <B2BLayout>{el}</B2BLayout>;
const b2c = (el, page) => <B2CLayout page={page}>{el}</B2CLayout>;

function App() {
  useEffect(() => { captureAttribution(); }, []);
  const b2cHost = isB2CHost();
  return (
    <div className="App">
      <SettingsProvider>
      <CopyProvider>
        <BrowserRouter>
          <GaPageViews />
          {b2cHost ? (
            <Routes>
              <Route path="/" element={b2c(<FlightsHome />, "/")} />
              <Route path="/deals" element={b2c(<Deals />, "/deals")} />
              <Route path="/popular-routes" element={b2c(<PopularRoutes />, "/popular-routes")} />
              <Route path="/season/:slug" element={b2c(<SeasonPage />, "season")} />
              <Route path="/go/:slug/:code" element={<GoRedirect />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/flights" element={<Navigate to="/" replace />} />
              <Route path="/flights/deals" element={<Navigate to="/deals" replace />} />
              <Route path="/flights/popular-routes" element={<Navigate to="/popular-routes" replace />} />
              <Route path="/flights/:slug" element={<FlightsSlugRedirect />} />
              <Route path="/:slug" element={b2c(<CampaignPage />, "campaign")} />
            </Routes>
          ) : (
            <Routes>
              <Route path="/" element={b2b(<Home />)} />
              <Route path="/what-is-sellvago" element={b2b(<WhatIsSellvago />)} />
              <Route path="/sellvago-vs-b2b-ota" element={b2b(<SellvagoVsB2bOta />)} />
              <Route path="/how-white-label-works" element={b2b(<HowWhiteLabelWorks />)} />
              <Route path="/how-resellers-grow" element={b2b(<HowResellersGrow />)} />
              <Route path="/about" element={b2b(<About />)} />
              <Route path="/solutions" element={b2b(<Solutions />)} />
              <Route path="/white-label-portal" element={b2b(<WhiteLabel />)} />
              <Route path="/affiliate-program" element={b2b(<Affiliate />)} />
              <Route path="/contact" element={b2b(<Contact />)} />
              <Route path="/signup" element={b2b(<Signup />)} />
              <Route path="/faq" element={b2b(<Faq />)} />
              <Route path="/privacy" element={b2b(<Privacy />)} />
              <Route path="/terms" element={b2b(<Terms />)} />

              <Route path="/flights" element={b2c(<FlightsHome />, "/flights")} />
              <Route path="/flights/deals" element={b2c(<Deals />, "/flights/deals")} />
              <Route path="/flights/popular-routes" element={b2c(<PopularRoutes />, "/flights/popular-routes")} />
              <Route path="/flights/season/:slug" element={b2c(<SeasonPage />, "season")} />
              <Route path="/flights/:slug" element={b2c(<CampaignPage />, "campaign")} />
              <Route path="/a/:code" element={b2c(<AffiliateLanding />, "affiliate-landing")} />
              <Route path="/a/:code/stats" element={b2c(<AffiliateStats />, "affiliate-stats")} />
              <Route path="/articles" element={b2c(<ArticlesList />, "articles")} />
              <Route path="/articles/:slug" element={b2c(<ArticleDetail />, "article")} />
              <Route path="/go/:slug/:code" element={<GoRedirect />} />

              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
          )}
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CopyProvider>
      </SettingsProvider>
    </div>
  );
}

function FlightsSlugRedirect() {
  const slug = window.location.pathname.replace(/^\/flights\//, "");
  return <Navigate to={`/${slug}`} replace />;
}

export default App;
